if (!customElements.get('meu-quick-add')) {
  // "[ Add to cart ]" under products. Products with sizes open a dropdown of sizes first.
  // Adds the same way the theme's product form does, so the cart drawer (or cart app)
  // and the cart count update as usual.
  class MeuQuickAdd extends HTMLElement {
    connectedCallback() {
      this.label = this.querySelector('.meu-add__label');
      this.labelText = this.label ? this.label.textContent.trim() : '';
      this.onClick = this.onClick.bind(this);
      this.onOutside = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.onKeydown = (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-choosing')) {
          this.close();
          this.label?.focus();
        }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onOutside);
      clearTimeout(this.timer);
    }

    onClick(event) {
      const button = event.target.closest('button');
      if (!button || button.disabled || !this.contains(button)) return;
      // Keep the click away from the product link and the carousel
      event.preventDefault();
      event.stopPropagation();
      if (button.dataset.variant) this.add(button.dataset.variant, button);
      else if (button.hasAttribute('data-choose')) {
        if (this.classList.contains('is-choosing')) this.close();
        else this.open();
      }
    }

    open() {
      this.classList.add('is-choosing');
      this.label?.setAttribute('aria-expanded', 'true');
      this.querySelector('.meu-add__size:not([disabled])')?.focus({ preventScroll: true });
      document.addEventListener('click', this.onOutside);
    }

    close() {
      if (!this.classList.contains('is-choosing')) return;
      this.classList.remove('is-choosing');
      this.label?.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this.onOutside);
    }

    // Show a short message in place of "[ Add to cart ]", then put it back
    say(text, duration) {
      if (!this.label) return;
      clearTimeout(this.timer);
      this.label.textContent = text;
      if (duration) this.timer = setTimeout(() => (this.label.textContent = this.labelText), duration);
    }

    async add(variantId, button) {
      if (this.busy) return;
      this.busy = true;
      this.close();
      this.say('[ Adding… ]');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = new FormData();
      body.append('id', variantId);
      body.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map((section) => section.id));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(button);
      }

      try {
        const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body,
        });
        const data = await response.json();
        if (data.status) {
          // e.g. sold out, or no more stock than what's already in the cart
          this.say(`[ ${data.description || data.message || 'Could not add'} ]`, 4000);
          return;
        }
        if (cart && typeof cart.renderContents === 'function') {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          this.refreshCount();
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'meutant-quick-add', productVariantId: variantId, cartData: data });
        }
        this.say('[ Added ]', 2200);
      } catch (error) {
        this.say('[ Try again ]', 3000);
      } finally {
        this.busy = false;
      }
    }

    // Without a cart drawer, redraw the header basket the same way the drawer does
    async refreshCount() {
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const sections = await (await fetch(`${root}?sections=cart-icon-bubble`)).json();
        const fresh = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        const bubble = document.getElementById('cart-icon-bubble');
        if (fresh && bubble) bubble.innerHTML = fresh.innerHTML;
      } catch (error) {
        // The count catches up on the next page load
      }
    }
  }

  customElements.define('meu-quick-add', MeuQuickAdd);
}
